import React, { useState, useImperativeHandle, forwardRef, useCallback } from "react";
import { useCountDown } from 'ahooks';
import { Input, Form, Row, Col, Button, message } from 'antd';
import { PhoneOutlined, MessageOutlined } from '@ant-design/icons';
import { sendSmsApi } from '../../../action';
import './index.scss';

type FieldType = {
    mobile?: string;
    code?: string;
};

// 定义 props 类型
interface MobileLoginProps {
    ref?: any;
    target: string;
}

const MobileLogin: React.FC<MobileLoginProps> = forwardRef((props, ref) => {
    const { target } = props;
    const [form] = Form.useForm();
    const [targetDate, setTargetDate] = useState<number>(0);
    const [countdown] = useCountDown({
        targetDate,
        onEnd: () => {
            //   alert('End of the time');
        },
    });

    // 暴露给父组件的值和方法
    useImperativeHandle(ref, () => ({
        getValues,
    }));

    // 表单提交
    const getValues: any = useCallback(() => {
        return new Promise((resolve, reject) => {
            form.validateFields().then((values) => {
                resolve(values);
            }).catch((error) => {
                console.log(error);
            });
        });
    }, [form]);

    // 倒计时
    const getSmsCode = useCallback(() => {
        form.validateFields(['mobile']).then(async (values) => {
            const res = await sendSmsApi({
                mobile: values.mobile,
                target: encodeURIComponent(target),
            });
            if (res.data.code === 0) {
                message.open({
                    type: 'success',
                    content: '验证码发送成功',
                });
                setTargetDate(Date.now() + 60 * 1000);
            } else if (res.data.code === 90900) {
                const options = {
                    sessionId: res.data.data.session_id, // 485返回数据中的sessionId
                    sumei: '', // 数美id
                    userId: '', // 用户id
                    domId: '', // 需要绑定的dom的id
                    lang: '', // 语言类型  详细见下表
                    success: () => { // 验证成功回调
                        // 成功后的逻辑
                        getSmsCode();
                    }
                };
                console.log(options);
                if (window.dewuCap) {
                    window.dewuCap(options);
                }
            } else {
                message.open({
                    type: 'error',
                    content: res.data.msg,
                });
            }
        }).catch((error) => {
            console.log(error);
        });

    }, [form, target]);

    return <div className="sso-login-mobile-mode">
        <Form
            name="mobile_info"
            form={form}
            initialValues={{
                mobile: '',
                code: ''
            }}
            autoComplete="false"
            onValuesChange={(changedValues) => {
                if (changedValues['code']) {
                    form.setFieldValue('code', changedValues['code'].replace(/\D/g, '').slice(0, 5));
                }
            }}
        >
            <Form.Item<FieldType>
                name="mobile"
                rules={[{ required: true, message: '手机号不能为空' }]}
            >
                <Input size="large" prefix={<PhoneOutlined />} placeholder="手机号" allowClear />
            </Form.Item>
            <Row gutter={10}>
                <Col span={16}>
                    <Form.Item<FieldType>
                        name="code"
                        rules={[{ required: true, message: '验证码不能为空' }]}
                    >
                        <Input size="large" prefix={<MessageOutlined />} placeholder="验证码" allowClear />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Button style={{ width: '100%' }} disabled={countdown !== 0} size="large" type="primary" onClick={getSmsCode}>
                        {countdown !== 0 ? `${Math.round(countdown / 1000)}s` : '获取验证码'}
                    </Button>
                </Col>
            </Row>

        </Form>
    </div>
});

export default MobileLogin;